import moment from 'moment';

const date1 = moment().format('YYYY-MM-DD');
const date2 = moment().format('YYYYMMDDHHmmss');

export function CreateContent(data) {

    // get somme of all 'Montant' values
    let sum = data.reduce((acc, item) => acc + parseFloat(item.montant), 0);
    // remplace '&' par '' dans le JSON
    // data = ;
    // remplace tpus les caracteres accentuées par leur équivalent non accentué
    let cleanstring = JSON.parse(JSON.stringify(data).replace(/&/g, '').replace(/é/g, 'e').replace(/è/g, 'e').replace(/ê/g, 'e').replace(/à/g, 'a').replace(/â/g, 'a').replace(/ù/g, 'u').replace(/û/g, 'u').replace(/ô/g, 'o').replace(/î/g, 'i').replace(/ç/g, 'c').replace(/ë/g, 'e').replace(/ï/g, 'i').replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ÿ/g, 'y').replace(/ñ/g, 'n').replace(/É/g, 'E').replace(/È/g, 'E').replace(/Ê/g, 'E').replace(/À/g, 'A').replace(/Â/g, 'A').replace(/Ù/g, 'U').replace(/Û/g, 'U').replace(/Ô/g, 'O').replace(/Î/g, 'I').replace(/Ç/g, 'C').replace(/Ë/g, 'E').replace(/Ï/g, 'I').replace(/Ü/g, 'U').replace(/Ö/g, 'O').replace(/Ÿ/g, 'Y').replace(/Ñ/g, 'N'));
    //cleanstring = cleanstring.replace(
    let content = `<?xml version="1.0" encoding="utf-8"?>
    <Document xmlns="urn:iso:std:iso:20022:tech:xsd:pain.008.001.02"
        xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="urn:iso:std:iso:20022:tech:xsd:pain.008.001.02 pain.008.001.02.xsd">
        <CstmrDrctDbtInitn>
            <GrpHdr><MsgId>FFC-${date2}</MsgId><CreDtTm>${date1}T12:10:38+02:00</CreDtTm><NbOfTxs>${data.length}</NbOfTxs><CtrlSum>${sum}</CtrlSum><InitgPty><Nm>FFC MOBILITE</Nm></InitgPty></GrpHdr>
            ${getBlocks(cleanstring)}
        </CstmrDrctDbtInitn>
    </Document>`;

    return content;
}

function getBlocks(data) {
    let content = '';

    // get all unique string values from an array of objects for a specific key (e.g. 'blocks')
    console.log(data);
    let uniqueBlocks = [...new Set(data.map(item => item.block))];
    console.log(uniqueBlocks);
    uniqueBlocks.forEach(block => {
        let blockData = data.filter(item => item.block === block);
        content += getBlock(blockData, block);
    });

    return content;
}

function getBlock(data, block) {
    let sum = data.reduce((acc, item) => acc + parseFloat(item.montant), 0);    
    let content = `
    <PmtInf>
        <PmtInfId>FFC-${date2}-${block}</PmtInfId>
        <PmtMtd>DD</PmtMtd>
        <NbOfTxs>${data.length}</NbOfTxs>
        <CtrlSum>${sum}</CtrlSum>
        <PmtTpInf><SvcLvl><Cd>SEPA</Cd></SvcLvl><LclInstrm><Cd>CORE</Cd></LclInstrm><SeqTp>${block}</SeqTp></PmtTpInf>
        <ReqdColltnDt>${date1}</ReqdColltnDt>
        <Cdtr><Nm>FFC MOBILITE REPARATION ET SERVICE</Nm></Cdtr>
        <CdtrAcct><Id><IBAN>FR7610207004262121226050594</IBAN></Id></CdtrAcct>
        <CdtrAgt><FinInstnId><BIC>CCBPFRPPMTG</BIC></FinInstnId></CdtrAgt>
        <CdtrSchmeId><Id><PrvtId><Othr><Id>FR40ZZZ420755</Id><SchmeNm><Prtry>SEPA</Prtry></SchmeNm></Othr></PrvtId></Id></CdtrSchmeId>

            ${getLines(data, block)}
    </PmtInf>
    `;
    return content;
}

function getLines(data, block) {
    let content = '';
    // foreach with index


    data.forEach((element, index) => {
        content += `<DrctDbtTxInf><PmtId><EndToEndId>FFC-${date2}-${index+1}-${block}</EndToEndId></PmtId><InstdAmt Ccy="EUR">${element.montant}</InstdAmt><DrctDbtTx><MndtRltdInf><MndtId>${element.rum}</MndtId><DtOfSgntr>${element.date_signe}</DtOfSgntr></MndtRltdInf></DrctDbtTx><DbtrAgt><FinInstnId><BIC>${element.bic}</BIC></FinInstnId></DbtrAgt><Dbtr><Nm>${element.entreprise}</Nm></Dbtr><DbtrAcct><Id><IBAN>${element.iban}</IBAN></Id></DbtrAcct><RmtInf><Ustrd>${element.libelle}</Ustrd></RmtInf></DrctDbtTxInf>
        `;
    });
    return content;
}

